<template>
  <div class="schedule-page">
    <!-- 标题行 -->
    <div class="title-row">
      <div class="title-left">
        <span class="page-title">排班管理</span>
        <span class="page-date-tag">
          <i class="el-icon-date" style="margin-right:4px"></i>{{ todayStr }}
        </span>
      </div>
      <div class="title-actions">
        <el-button size="small" @click="openCopyModal">
          <i class="el-icon-document-copy"></i> 复制排班
        </el-button>
        <el-button size="small" @click="exportData">
          <i class="el-icon-download"></i> 导出
        </el-button>
        <el-button type="primary" size="small" @click="openAddModal(null)">
          <i class="el-icon-plus"></i> 新增排班
        </el-button>
      </div>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="sc-left sc-green"><i class="el-icon-user-solid sc-icon"></i></div>
        <div class="sc-right">
          <div class="sc-num">{{ stats.todayOnDuty }}</div>
          <div class="sc-label">今日在班</div>
          <div class="sc-sub">护工人数</div>
        </div>
        <div class="sc-badge sc-badge-green">在岗</div>
      </div>
      <div class="stat-card">
        <div class="sc-left sc-orange"><i class="el-icon-date sc-icon"></i></div>
        <div class="sc-right">
          <div class="sc-num">{{ stats.todayOff }}</div>
          <div class="sc-label">今日休假</div>
          <div class="sc-sub">含年假病假</div>
        </div>
        <div class="sc-badge sc-badge-orange">休息</div>
      </div>
      <div class="stat-card">
        <div class="sc-left sc-blue"><i class="el-icon-time sc-icon"></i></div>
        <div class="sc-right">
          <div class="sc-num">{{ stats.monthTotal }}</div>
          <div class="sc-label">本月总班次</div>
          <div class="sc-sub">已完成 {{ stats.monthDone }} 次</div>
        </div>
        <div class="sc-progress-wrap">
          <div class="sc-progress-bar">
            <div class="sc-progress-fill" :style="{ width: stats.monthTotal ? Math.round(stats.monthDone / stats.monthTotal * 100) + '%' : '0%' }"></div>
          </div>
          <span class="sc-progress-pct">{{ stats.monthTotal ? Math.round(stats.monthDone / stats.monthTotal * 100) : 0 }}%</span>
        </div>
      </div>
    </div>

    <!-- 主卡片 -->
    <div class="main-card">
      <!-- 筛选栏 -->
      <div class="filter-bar">
        <div class="filter-left">
          <!-- 日期导航 -->
          <div class="date-nav-group">
            <el-button size="mini" icon="el-icon-arrow-left" @click="prevWeek"></el-button>
            <span class="date-range-label">{{ dateRangeLabel }}</span>
            <el-button size="mini" icon="el-icon-arrow-right" @click="nextWeek"></el-button>
          </div>
          <!-- 快捷跳转 -->
          <div class="quick-jump-group">
            <span class="quick-jump-btn" :class="{ active: quickMode === 'week' }" @click="jumpThisWeek">本周</span>
            <span class="quick-jump-btn" :class="{ active: quickMode === 'next' }" @click="jumpNextWeek">下周</span>
            <span class="quick-jump-btn" :class="{ active: quickMode === 'month' }" @click="jumpThisMonth">本月</span>
          </div>
          <div class="filter-divider"></div>
          <el-select v-model="filterGroup" placeholder="全部班组" clearable size="mini" style="width:110px" @change="onGroupFilterChange">
            <el-option v-for="g in nursingGroupList" :key="g.id" :value="g.id" :label="g.name"></el-option>
          </el-select>
          <el-select v-model="filterBuilding" placeholder="全部楼栋" clearable size="mini" style="width:110px" @change="onFilterChange">
            <el-option v-for="b in roomBuildings" :key="b.buildingId" :value="b.buildingId" :label="b.buildingName"></el-option>
          </el-select>
          <el-select v-model="filterShift" placeholder="全部班次" clearable size="mini" style="width:110px" @change="onFilterChange">
            <el-option v-for="s in shiftList" :key="s.id" :value="s.id" :label="s.name"></el-option>
          </el-select>
        </div>
        <div class="filter-right">
          <div class="view-switch">
            <span class="view-btn" :class="{ active: viewMode === 'week' }" @click="viewMode = 'week'">
              <i class="el-icon-menu" style="margin-right:4px"></i>时间视图
            </span>
            <span class="view-btn" :class="{ active: viewMode === 'room' }" @click="viewMode = 'room'">
              <i class="el-icon-office-building" style="margin-right:4px"></i>房间视图
            </span>
            <span class="view-btn" :class="{ active: viewMode === 'staff' }" @click="viewMode = 'staff'">
              <i class="el-icon-user" style="margin-right:4px"></i>人员视图
            </span>
          </div>
        </div>
      </div>

      <!-- 时间视图 -->
      <div v-if="viewMode === 'week'" class="schedule-wrap">
        <div class="s-scroll-x">
          <table class="s-table">
            <thead>
              <tr>
                <th class="s-th-date">日期</th>
                <th v-for="s in shiftList" :key="s.id" class="s-th-shift">
                  <div class="s-th-shift-inner">
                    <span class="s-dot" :style="{ background: s.color || '#2563EB' }"></span>
                    <div>
                      <div class="s-shift-name">{{ s.name }}</div>
                      <div class="s-shift-time">{{ s.time }}</div>
                    </div>
                  </div>
                </th>
                <th v-if="!shiftList.length" class="s-th-shift" style="color:#94A3B8;font-size:12px">暂无班次配置</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="day in weekDays" :key="day.date" :class="{ 'is-today': day.date === todayStr }">
                <td class="s-td-date">
                  <span class="s-week">{{ day.weekLabel }}</span>
                  <span class="s-day" :class="{ 'today-circle': day.date === todayStr }">{{ day.dayLabel }}</span>
                </td>
                <td v-for="shift in shiftList" :key="shift.id" class="s-td-cell" :class="{ 'cell-warn': isUnderstaffed(day.date, shift.id) }">
                  <div class="s-cell-inner">
                    <div
                      v-for="s in getMergedSchedules(day.date, shift.id)"
                      :key="s.staffId"
                      class="staff-chip"
                      :style="{ background: hexToLight(shift.color), borderLeft: '3px solid ' + (shift.color || '#2563EB') }"
                      @click="openDetailModal(s)">
                      <span class="chip-avatar" :style="{ background: shift.color || '#2563EB' }">{{ s.staffName ? s.staffName.charAt(0) : '' }}</span>
                      <span class="chip-name">{{ s.staffName }}</span>
                      <span class="chip-rooms" v-if="s.roomList && s.roomList.length">
                        <i class="el-icon-house" style="font-size:10px;opacity:0.6;flex-shrink:0;margin-right:2px"></i>
                        <span class="chip-rooms-text">{{ s.roomList.map(r => r.roomNo).join(' ') }}</span>
                      </span>
                    </div>
                    <!-- 完全无排班警告 -->
                    <div v-if="isUnderstaffed(day.date, shift.id)" class="empty-warn">
                      <div class="warn-inner">
                        <i class="el-icon-warning" style="color:#F59E0B;font-size:20px;flex-shrink:0"></i>
                        <div class="warn-content">
                          <div class="warn-title">{{ shift.name }}暂无排班</div>
                          <div class="warn-desc">存在漏排风险</div>
                        </div>
                      </div>
                      <div class="warn-btn" @click="openAddModal({ date: day.date, shiftId: shift.id, shiftName: shift.name, shiftColor: shift.color, isQuickFill: true })">
                        <i class="el-icon-plus" style="font-size:12px"></i><span>立即补排</span>
                      </div>
                    </div>
                    <!-- 部分房间漏排提示 -->
                    <div v-else-if="getMissingRooms(day.date, shift.id).length" class="missing-rooms-warn">
                      <div class="missing-rooms-header">
                        <i class="el-icon-warning-outline" style="color:#F59E0B;font-size:12px;flex-shrink:0"></i>
                        <span class="missing-rooms-title">漏排 {{ getMissingRooms(day.date, shift.id).length }} 间</span>
                        <div class="missing-rooms-btn" @click="openAddModal({ date: day.date, shiftId: shift.id, shiftName: shift.name, shiftColor: shift.color, isQuickFill: true })">
                          <i class="el-icon-plus" style="font-size:11px"></i>补排
                        </div>
                      </div>
                      <div class="missing-rooms-list">
                        <span v-for="r in getMissingRooms(day.date, shift.id).slice(0, 6)" :key="r.roomId" class="missing-room-tag">{{ r.roomNo }}</span>
                        <span v-if="getMissingRooms(day.date, shift.id).length > 6" class="missing-room-more">+{{ getMissingRooms(day.date, shift.id).length - 6 }}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="s-td-cell" v-if="!shiftList.length"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 图例 -->
        <div class="s-legend">
          <span style="color:#64748B;font-weight:500">说明：</span>
          <span class="legend-item" v-for="s in shiftList" :key="s.id">
            <span class="legend-dot" :style="{ background: s.color || '#2563EB' }"></span>
            {{ s.name }} {{ s.time }}
          </span>
          <span class="legend-sep" v-if="shiftList.length"></span>
          <span class="legend-item">
            <span class="legend-dot" style="background:#F59E0B"></span>
            黄色背景 = 漏排警告
          </span>
        </div>
      </div>

      <!-- 房间视图 -->
      <room-view
        v-else-if="viewMode === 'room'"
        :schedule-list="filteredScheduleList"
        :room-list="filterBuilding !== '' ? roomList.filter(r => String(r.buildingId) === String(filterBuilding)) : roomList"
        :shift-list="filterShift ? shiftList.filter(s => String(s.id) === String(filterShift)) : shiftList"
        :week-days="weekDays"
        :today-str="todayStr"
        @add="openAddModal"
        @edit="openDetailModal">
      </room-view>

      <!-- 人员视图 -->
      <staff-view
        v-else-if="viewMode === 'staff'"
        :schedule-list="filteredScheduleList"
        :staff-list="staffList"
        :shift-list="filterShift ? shiftList.filter(s => String(s.id) === String(filterShift)) : shiftList"
        :week-days="weekDays"
        :today-str="todayStr"
        :range-label="currentRangeLabel"
        @add="openAddModal"
        @edit="openDetailModal">
      </staff-view>
    </div>

    <!-- 新增/编辑排班弹窗 -->
    <el-dialog
      :visible.sync="addModalVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="560px"
      custom-class="add-schedule-dialog">
      <div class="add-modal">
        <div class="add-modal-header">
          <div class="add-modal-title">{{ editingSchedule ? '修改排班' : '新增排班' }}</div>
          <div class="add-modal-close" @click="addModalVisible = false">
            <i class="el-icon-close" style="color:#94A3B8;font-size:16px"></i>
          </div>
        </div>
        <div class="add-modal-body">
          <!-- 修改信息条 -->
          <div v-if="editingSchedule" class="edit-info-bar">
            <i class="el-icon-info" style="color:#2563EB;font-size:15px;flex-shrink:0"></i>
            <div style="margin-left:10px">
              <div class="edit-info-title">
                正在修改：{{ editingSchedule.staffName }} · {{ getWeekLabel(editingSchedule.date) }} {{ editingSchedule.date ? editingSchedule.date.substring(0, 10) : '' }} · {{ editingSchedule.shiftName }}
              </div>
              <div class="edit-info-sub">修改后将立即生效，如需通知护工请手动发送</div>
            </div>
          </div>
          <!-- 选择员工 -->
          <div class="add-field">
            <div class="add-label">选择员工 <span class="req">*</span></div>
            <el-select v-model="scheduleForm.staffId" placeholder="请选择员工" filterable style="width:100%" @change="onStaffChange">
              <el-option v-for="s in staffList" :key="s.userId" :value="s.userId" :label="s.realName || s.userName"></el-option>
            </el-select>
          </div>
          <!-- 班次类型 -->
          <div class="add-field">
            <div class="add-label">班次类型 <span class="req">*</span></div>
            <div class="shift-btn-row">
              <div
                v-for="s in shiftList"
                :key="s.id"
                class="shift-btn"
                :class="{ active: scheduleForm.shiftId === s.id }"
                :style="scheduleForm.shiftId === s.id ? { borderColor: s.color || '#2563EB', background: (s.color || '#2563EB') + '15' } : {}"
                @click="onShiftBtnClick(s)">
                <span class="shift-btn-dot" :style="{ background: scheduleForm.shiftId === s.id ? (s.color || '#2563EB') : '#CBD5E1' }"></span>
                <div>
                  <div class="shift-btn-name" :style="scheduleForm.shiftId === s.id ? { color: s.color || '#2563EB' } : {}">{{ s.name }}</div>
                  <div class="shift-btn-time">{{ s.time }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 负责房间 -->
          <div class="add-field">
            <div class="add-label">负责房间 <span class="req">*</span></div>
            <div class="room-input-box" @click="roomPickerVisible = true">
              <span v-if="!scheduleForm.roomIds.length" class="room-placeholder">点击选择负责房间</span>
              <span v-for="id in scheduleForm.roomIds" :key="id" class="room-tag">
                {{ getRoomNoById(id) }}
                <i class="el-icon-close" style="font-size:10px;cursor:pointer" @click.stop="removeRoom(id)"></i>
              </span>
              <span class="room-add-btn"><i class="el-icon-plus" style="font-size:12px"></i> 按范围添加</span>
            </div>
            <div class="room-hint">支持单选、范围选择或分组选择</div>
            <div class="quick-row">
              <span class="quick-label">快捷选择：</span>
              <span v-for="group in roomBuildingFloors" :key="group.key" class="quick-btn" @click="quickSelectBuildingFloor(group)">{{ group.label }}</span>
              <el-link type="primary" style="font-size:12px" @click="roomPickerVisible = true">更多...</el-link>
            </div>
          </div>
          <!-- 排班日期 -->
          <div class="add-field">
            <div class="add-label">排班日期 <span class="req">*</span></div>
            <div class="date-row">
              <el-date-picker v-model="scheduleForm.dateStart" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" style="flex:1"></el-date-picker>
              <span style="color:#94A3B8;padding:0 8px">至</span>
              <el-date-picker v-model="scheduleForm.dateEnd" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" style="flex:1"></el-date-picker>
            </div>
          </div>
          <!-- 备注 -->
          <div class="add-field">
            <div class="add-label">备注说明</div>
            <el-input v-model="scheduleForm.remark" type="textarea" placeholder="请输入备注信息（选填）" :maxlength="200" show-word-limit :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
          </div>
        </div>
        <div class="add-modal-footer">
          <el-button v-if="editingSchedule" type="danger" plain style="float:left;margin-right:auto" :loading="deleting" @click="deleteSchedule(editingSchedule.id)">删除排班</el-button>
          <el-button @click="addModalVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitting" @click="submitSchedule">{{ editingSchedule ? '保存修改' : '确认新增' }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 房间选择器 -->
    <room-picker
      :visible="roomPickerVisible"
      :rooms="roomList"
      :selected="scheduleForm.roomIds"
      @update:visible="roomPickerVisible = $event"
      @confirm="onRoomPickerConfirm">
    </room-picker>

    <!-- 立即补排弹窗 -->
    <quick-fill-modal
      :visible="quickFillVisible"
      :date="quickFillPreset.date"
      :shift-id="quickFillPreset.shiftId"
      :shift-name="quickFillPreset.shiftName"
      :shift-color="quickFillPreset.shiftColor"
      :staff-list="staffList"
      :rooms="roomList"
      :shift-list="shiftList"
      @update:visible="quickFillVisible = $event"
      @submit="handleQuickFillSubmit"
      @staffSearch="onStaffSearch">
    </quick-fill-modal>

    <!-- 复制排班弹窗 -->
    <el-dialog
      :visible.sync="copyModalVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="520px"
      custom-class="copy-schedule-dialog">
      <div class="cp-modal">
        <div class="cp-modal-header">
          <div class="cp-modal-header-left">
            <div class="cp-modal-icon"><i class="el-icon-document-copy" style="font-size:18px;color:#fff"></i></div>
            <div>
              <div class="cp-modal-title">复制排班</div>
              <div class="cp-modal-sub">将当前周排班批量复制到其他时间段</div>
            </div>
          </div>
          <div class="cp-modal-close" @click="copyModalVisible = false">
            <i class="el-icon-close" style="font-size:15px;color:rgba(255,255,255,0.7)"></i>
          </div>
        </div>
        <div class="cp-modal-body">
          <!-- 来源 -->
          <div class="cp-block">
            <div class="cp-block-title"><span class="cp-block-dot cp-dot-blue"></span>复制来源</div>
            <div class="cp-source-box">
              <div class="cp-source-icon"><i class="el-icon-date" style="font-size:16px;color:#2563EB"></i></div>
              <div class="cp-source-info">
                <div class="cp-source-week">本周排班</div>
                <div class="cp-source-range">{{ copyFromLabel }}</div>
              </div>
              <span class="cp-current-tag">当前周</span>
            </div>
          </div>
          <!-- 复制到 -->
          <div class="cp-block">
            <div class="cp-block-title"><span class="cp-block-dot cp-dot-blue"></span>复制到 <span class="cp-required">*</span></div>
            <div class="cp-target-grid">
              <div v-for="opt in copyTargetOptions" :key="opt.value" class="cp-target-card" :class="{ active: copyForm.targetMode === opt.value }" @click="copyForm.targetMode = opt.value">
                <div class="cp-card-check" :class="{ active: copyForm.targetMode === opt.value }">
                  <i v-if="copyForm.targetMode === opt.value" class="el-icon-check" style="font-size:10px;color:#fff"></i>
                </div>
                <div class="cp-card-label">{{ opt.label }}</div>
                <div class="cp-card-range">{{ opt.range }}</div>
              </div>
            </div>
            <div v-if="copyForm.targetMode === 'custom'" style="margin-top:10px">
              <el-date-picker v-model="copyForm.customRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
            </div>
          </div>
          <!-- 冲突处理 -->
          <div class="cp-block">
            <div class="cp-block-title"><span class="cp-block-dot cp-dot-orange"></span>已有排班时</div>
            <div class="cp-conflict-row">
              <div class="cp-conflict-card" :class="{ active: copyForm.conflictMode === 'skip' }" @click="copyForm.conflictMode = 'skip'">
                <div class="cp-conflict-radio" :class="{ active: copyForm.conflictMode === 'skip' }"></div>
                <div><div class="cp-conflict-name">跳过</div><div class="cp-conflict-desc">保留已有排班不覆盖</div></div>
              </div>
              <div class="cp-conflict-card" :class="{ active: copyForm.conflictMode === 'overwrite' }" @click="copyForm.conflictMode = 'overwrite'">
                <div class="cp-conflict-radio" :class="{ active: copyForm.conflictMode === 'overwrite' }"></div>
                <div><div class="cp-conflict-name">覆盖</div><div class="cp-conflict-desc">替换目标时段排班</div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="cp-modal-footer">
          <el-button @click="copyModalVisible = false" :disabled="copying">取消</el-button>
          <el-button type="primary" @click="submitCopy" :loading="copying">
            <i class="el-icon-document-copy"></i> 确认复制
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RoomView from './components/RoomView.vue'
import StaffView from './components/StaffView.vue'
import RoomPicker from './components/RoomPicker.vue'
import QuickFillModal from './components/QuickFillModal.vue'
import {
  getRoomScheduleList, addRoomSchedule, editRoomSchedule, deleteRoomSchedule,
  copyWeekSchedule, exportSchedule, getShiftList, getRoomList,
  getNursingGroupList, getNursingGroupMembers, getNursingStaffList, getAllNursingStaff
} from './scheduleApi'
import {
  hexToLight, getWeekLabel, buildWeekDays, buildRoomBuildingFloors,
  getTodayStr, getIsoWeekStart, getIsoWeekEnd, getMonthStart, getMonthEnd,
  addDays, diffDays, getIsoWeekNumber
} from './scheduleUtils'

export default {
  name: 'ScheduleIndex',
  components: { RoomView, StaffView, RoomPicker, QuickFillModal },
  data() {
    var todayStr = getTodayStr()
    return {
      todayStr,
      scheduleList: [],
      shiftList: [],
      staffList: [],
      roomList: [],
      nursingGroupList: [],
      totalStaffCount: 0,
      filterBuilding: '',
      filterShift: '',
      filterGroup: '',
      filterGroupMemberIds: new Set(),
      weekValue: getTodayStr(),
      isMonthMode: false,
      quickMode: 'week',
      viewMode: 'week',
      addModalVisible: false,
      editingSchedule: null,
      roomPickerVisible: false,
      quickFillVisible: false,
      quickFillPreset: {},
      submitting: false,
      deleting: false,
      copyModalVisible: false,
      copying: false,
      scheduleForm: {
        staffId: '', staffName: '',
        shiftId: '', shiftName: '', shiftColor: '',
        date: '', dateStart: '', dateEnd: '',
        status: 0, remark: '',
        roomIds: [], roomList: []
      },
      copyForm: {
        fromWeek: '',
        targetMode: 'next',
        conflictMode: 'skip',
        customRange: []
      }
    }
  },
  computed: {
    weekStart() {
      return getIsoWeekStart(this.weekValue)
    },
    weekEnd() {
      return getIsoWeekEnd(this.weekValue)
    },
    rangeStart() {
      return this.isMonthMode
        ? getMonthStart(this.weekValue)
        : this.weekStart
    },
    rangeEnd() {
      return this.isMonthMode
        ? getMonthEnd(this.weekValue)
        : this.weekEnd
    },
    dateRangeLabel() {
      var s = this.rangeStart
      var e = this.rangeEnd
      return s.replace(/-/g, '/') + ' - ' + e.substring(5).replace('-', '/')
    },
    weekDays() {
      return buildWeekDays(this.rangeStart, this.rangeEnd)
    },
    currentRangeLabel() {
      if (this.isMonthMode) return '本月'
      if (this.quickMode === 'next') return '下周'
      return '本周'
    },
    roomBuildings() {
      const map = {}
      for (const r of this.roomList) {
        if (r.buildingId != null && !map[r.buildingId]) {
          map[r.buildingId] = r.buildingName || `楼栋${r.buildingId}`
        }
      }
      return Object.keys(map).map(id => ({ buildingId: id, buildingName: map[id] }))
    },
    roomBuildingFloors() {
      return buildRoomBuildingFloors(this.roomList)
    },
    roomIdToBuildingId() {
      const m = {}
      for (const r of this.roomList) {
        if (r.roomId != null && r.buildingId != null) {
          m[String(r.roomId)] = String(r.buildingId)
        }
      }
      return m
    },
    filteredScheduleList() {
      return this.scheduleList.filter(s => {
        if (this.filterShift && String(s.shiftId) !== String(this.filterShift)) return false
        if (this.filterBuilding !== '' && !this.scheduleMatchesBuilding(s, this.filterBuilding)) return false
        if (this.filterGroup && this.filterGroupMemberIds.size > 0) {
          if (!this.filterGroupMemberIds.has(String(s.staffId))) return false
        }
        return true
      })
    },
    stats() {
      const todayList = this.scheduleList.filter(s => s.date && s.date.substring(0, 10) === this.todayStr)
      const todayOnDuty = new Set(todayList.map(s => s.staffId)).size
      return {
        todayOnDuty,
        todayOff: Math.max(0, this.totalStaffCount - todayOnDuty),
        monthTotal: this.scheduleList.length,
        monthDone: this.scheduleList.filter(s => s.date && s.date.substring(0, 10) < this.todayStr).length
      }
    },
    copyFromLabel() {
      if (!this.copyForm.fromWeek) return ''
      var s = getIsoWeekStart(this.copyForm.fromWeek)
      var e = getIsoWeekEnd(this.copyForm.fromWeek)
      var weekNum = getIsoWeekNumber(s)
      return s.replace(/-/g, '/') + ' - ' + e.substring(5).replace('-', '/') + '（第' + weekNum + '周）'
    },
    copyTargetOptions() {
      var nextStart = addDays(this.weekStart, 7)
      var next2Start = addDays(this.weekStart, 14)
      var monthRemainStart = addDays(getTodayStr(), 1)
      var monthEnd = getMonthEnd(getTodayStr())
      return [
        { value: 'next', label: '下一周', range: nextStart.substring(5).replace('-', '/') + ' - ' + addDays(nextStart, 6).substring(5).replace('-', '/') },
        { value: 'next2', label: '下两周', range: next2Start.substring(5).replace('-', '/') + ' - ' + addDays(next2Start, 6).substring(5).replace('-', '/') },
        { value: 'monthRemain', label: '本月剩余', range: monthRemainStart.substring(5).replace('-', '/') + ' - ' + monthEnd.substring(5).replace('-', '/') },
        { value: 'custom', label: '自定义', range: '选择日期范围' }
      ]
    }
  },
  mounted() {
    this.loadShifts()
    this.loadStaff()
    this.loadRooms()
    this.loadNursingGroups()
    this.fetchData()
  },
  methods: {
    hexToLight,
    getWeekLabel,
    scheduleMatchesBuilding(s, buildingId) {
      const rooms = s.roomList || []
      return rooms.some(r => {
        if (r.buildingId != null) return String(r.buildingId) === String(buildingId)
        return this.roomIdToBuildingId[String(r.roomId)] === String(buildingId)
      })
    },
    async fetchData() {
      try {
        const res = await getRoomScheduleList({ weekStart: this.rangeStart, weekEnd: this.rangeEnd, pageSize: 500 })
        if (res && res.code == 200) {
          const data = res.result || res
          this.scheduleList = data.list || data.records || (Array.isArray(data) ? data : [])
        }
      } catch (e) { /* silent */ }
    },
    async loadShifts() {
      const res = await getShiftList()
      if (res && res.code == 200) {
        const data = res.result || res
        this.shiftList = Array.isArray(data) ? data : (data.list || data.records || [])
      }
    },
    async loadStaff(keyword) {
      // 优先用全量护工接口（不限班组），搜索时降级用分页接口
      if (!keyword) {
        const res = await getAllNursingStaff()
        if (res && res.code == 200) {
          const data = res.result || res
          const list = Array.isArray(data) ? data : (data.list || data.records || [])
          this.staffList = list
          this.totalStaffCount = list.length
          return
        }
      }
      // 关键词搜索时用分页接口
      const res = await getNursingStaffList({ pageNum: 1, pageSize: 500, userName: keyword || undefined })
      if (res && res.code == 200) {
        const data = res.result || res
        const list = data.list || data.records || (Array.isArray(data) ? data : [])
        this.staffList = list
        if (!keyword) this.totalStaffCount = data.total || list.length
      }
    },
    async loadRooms() {
      const res = await getRoomList()
      if (res && res.code == 200) {
        const data = res.result || res
        this.roomList = Array.isArray(data) ? data : (data.list || data.records || [])
      }
    },
    async loadNursingGroups() {
      const res = await getNursingGroupList()
      if (res && res.code == 200) {
        const data = res.result || res
        this.nursingGroupList = Array.isArray(data) ? data : (data.list || data.records || [])
      }
    },
    onStaffSearch(val) { this.loadStaff(val) },
    onStaffChange(val) {
      const s = this.staffList.find(x => x.userId === val)
      if (s) { this.scheduleForm.staffName = s.realName || s.userName }
    },
    onShiftBtnClick(s) {
      this.scheduleForm.shiftId = s.id
      this.scheduleForm.shiftName = s.name
      this.scheduleForm.shiftColor = s.color || '#2563EB'
    },
    onFilterChange() {},
    async onGroupFilterChange(val) {
      if (!val) { this.filterGroupMemberIds = new Set(); return }
      try {
        const res = await getNursingGroupMembers(val)
        if (res && res.code == 200) {
          const data = res.result || res
          const list = data.list || data.data || (Array.isArray(data) ? data : [])
          this.filterGroupMemberIds = new Set(list.map(u => String(u.userId || u.userid)))
        }
      } catch { this.filterGroupMemberIds = new Set() }
    },
    prevWeek() {
      this.weekValue = addDays(this.weekStart, -7)
      this.isMonthMode = false; this.quickMode = ''; this.fetchData()
    },
    nextWeek() {
      this.weekValue = addDays(this.weekStart, 7)
      this.isMonthMode = false; this.quickMode = ''; this.fetchData()
    },
    jumpThisWeek() {
      this.weekValue = getIsoWeekStart(getTodayStr())
      this.isMonthMode = false; this.quickMode = 'week'; this.fetchData()
    },
    jumpNextWeek() {
      this.weekValue = addDays(getIsoWeekStart(getTodayStr()), 7)
      this.isMonthMode = false; this.quickMode = 'next'; this.fetchData()
    },
    jumpThisMonth() {
      this.weekValue = getMonthStart(getTodayStr())
      this.isMonthMode = true; this.quickMode = 'month'; this.fetchData()
    },
    getCellSchedules(date, shiftId) {
      if (this.filterShift && String(this.filterShift) !== String(shiftId)) return []
      return this.scheduleList.filter(s => {
        if (!s.date || s.date.substring(0, 10) !== date) return false
        if (String(s.shiftId) !== String(shiftId)) return false
        if (this.filterBuilding !== '' && !this.scheduleMatchesBuilding(s, this.filterBuilding)) return false
        if (this.filterGroup && this.filterGroupMemberIds.size > 0) {
          if (!this.filterGroupMemberIds.has(String(s.staffId))) return false
        }
        return true
      })
    },
    getMergedSchedules(date, shiftId) {
      const schedules = this.getCellSchedules(date, shiftId)
      const map = {}
      for (const s of schedules) {
        const key = String(s.staffId)
        if (!map[key]) {
          map[key] = { ...s, roomList: [...(s.roomList || [])] }
        } else {
          const existingRoomIds = new Set(map[key].roomList.map(r => r.roomId))
          for (const r of (s.roomList || [])) {
            if (!existingRoomIds.has(r.roomId)) { map[key].roomList.push(r); existingRoomIds.add(r.roomId) }
          }
        }
      }
      return Object.values(map)
    },
    isUnderstaffed(date, shiftId) {
      if (date > this.todayStr) return false
      if (this.filterShift && String(this.filterShift) !== String(shiftId)) return false
      return this.getCellSchedules(date, shiftId).length === 0
    },
    getMissingRooms(date, shiftId) {
      if (date > this.todayStr) return []
      const schedules = this.getCellSchedules(date, shiftId)
      if (!schedules.length) return []
      const coveredIds = new Set()
      schedules.forEach(s => (s.roomList || []).forEach(r => coveredIds.add(String(r.roomId))))
      return this.roomList.filter(r => {
        if (coveredIds.has(String(r.roomId))) return false
        if (this.filterBuilding !== '' && String(r.buildingId) !== String(this.filterBuilding)) return false
        return true
      })
    },
    getRoomNoById(id) {
      const r = this.roomList.find(r => r.roomId === id)
      return r ? r.roomNo : id
    },
    removeRoom(id) {
      const idx = this.scheduleForm.roomIds.indexOf(id)
      if (idx >= 0) this.scheduleForm.roomIds.splice(idx, 1)
    },
    onRoomPickerConfirm(rooms) {
      this.scheduleForm.roomIds = rooms.map(r => r.roomId)
      this.scheduleForm.roomList = rooms
    },
    quickSelectBuildingFloor(group) {
      const ids = this.roomList
        .filter(r => (r.buildingId != null ? r.buildingId : 0) === group.buildingId && r.floorNo === group.floorNo)
        .map(r => r.roomId)
      ids.forEach(id => { if (!this.scheduleForm.roomIds.includes(id)) this.scheduleForm.roomIds.push(id) })
    },
    openAddModal(preset) {
      if (preset && preset.isQuickFill) {
        this.quickFillPreset = preset
        this.quickFillVisible = true
        return
      }
      this.editingSchedule = null
      Object.assign(this.scheduleForm, {
        staffId: '', staffName: '',
        shiftId: preset ? (preset.shiftId || '') : '',
        shiftName: preset ? (preset.shiftName || '') : '',
        shiftColor: preset ? (preset.shiftColor || '') : '',
        date: preset ? (preset.date || '') : '',
        dateStart: preset ? (preset.date || this.weekStart) : this.weekStart,
        dateEnd: preset ? (preset.date || this.weekEnd) : this.weekEnd,
        status: 0, remark: '', roomIds: [], roomList: []
      })
      this.addModalVisible = true
    },
    openDetailModal(s) {
      this.editingSchedule = s
      if (s.staffId && !this.staffList.find(e => e.userId === s.staffId)) {
        this.staffList = [{ userId: s.staffId, userName: s.staffName, realName: s.staffName }, ...this.staffList]
      }
      Object.assign(this.scheduleForm, {
        staffId: s.staffId, staffName: s.staffName,
        shiftId: s.shiftId, shiftName: s.shiftName, shiftColor: s.shiftColor,
        date: s.date ? s.date.substring(0, 10) : '',
        dateStart: s.date ? s.date.substring(0, 10) : '',
        dateEnd: s.date ? s.date.substring(0, 10) : '',
        status: s.status, remark: s.remark || '',
        roomIds: s.roomList ? s.roomList.map(r => r.roomId) : [],
        roomList: s.roomList || []
      })
      this.addModalVisible = true
    },
    submitSchedule() {
      if (!this.scheduleForm.staffId) { this.$message.warning('请选择员工'); return }
      if (!this.scheduleForm.shiftId) { this.$message.warning('请选择班次'); return }
      if (!this.scheduleForm.dateStart) { this.$message.warning('请选择排班日期'); return }
      const roomListPayload = this.scheduleForm.roomIds.map(id => {
        const r = this.roomList.find(x => x.roomId === id)
        return { roomId: id, roomNo: r ? r.roomNo : String(id) }
      })
      this.submitting = true
      if (this.editingSchedule) {
        editRoomSchedule({ ...this.scheduleForm, date: this.scheduleForm.dateStart, roomList: roomListPayload, id: this.editingSchedule.id }).then(res => {
          if (res && res.code == 200) { this.$message.success('修改成功'); this.addModalVisible = false; this.fetchData() }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      } else {
        var startDate = this.scheduleForm.dateStart
        var endDate = this.scheduleForm.dateEnd || this.scheduleForm.dateStart
        var days = diffDays(startDate, endDate) + 1
        var promises = []
        for (var i = 0; i < days; i++) {
          var date = addDays(startDate, i)
          promises.push(addRoomSchedule({ ...this.scheduleForm, date: date, roomList: roomListPayload }))
        }
        Promise.all(promises).then(results => {
          const successCount = results.filter(r => r && r.code == 200).length
          if (successCount > 0) { this.$message.success(`新增成功，共创建 ${successCount} 条排班`); this.addModalVisible = false; this.fetchData() }
          this.submitting = false
        }).catch(() => { this.submitting = false })
      }
    },
    deleteSchedule(id) {
      this.deleting = true
      deleteRoomSchedule(id).then(res => {
        if (res && res.code == 200) { this.$message.success('删除成功'); this.addModalVisible = false; this.fetchData() }
        this.deleting = false
      }).catch(() => { this.deleting = false })
    },
    async handleQuickFillSubmit(data) {
      const res = await addRoomSchedule(data)
      if (res && res.code == 200) { this.$message.success('补排成功'); this.fetchData() }
    },
    openCopyModal() {
      this.copyForm.fromWeek = this.weekStart
      this.copyForm.targetMode = 'next'
      this.copyForm.conflictMode = 'skip'
      this.copyForm.customRange = []
      this.copyModalVisible = true
    },
    submitCopy() {
      var fromStart = getIsoWeekStart(this.copyForm.fromWeek)
      var fromEnd = getIsoWeekEnd(this.copyForm.fromWeek)
      var toStart = ''
      if (this.copyForm.targetMode === 'next') toStart = addDays(this.weekStart, 7)
      else if (this.copyForm.targetMode === 'next2') toStart = addDays(this.weekStart, 14)
      else if (this.copyForm.targetMode === 'monthRemain') toStart = addDays(getTodayStr(), 1)
      else if (this.copyForm.targetMode === 'custom' && this.copyForm.customRange && this.copyForm.customRange[0]) toStart = this.copyForm.customRange[0]
      if (!toStart) { this.$message.warning('请选择复制目标'); return }
      this.copying = true
      copyWeekSchedule({ fromWeekStart: fromStart, fromWeekEnd: fromEnd, toWeekStart: toStart, conflictMode: this.copyForm.conflictMode }).then(res => {
        if (res && res.code == 200) { this.$message.success(`复制成功`); this.copyModalVisible = false; this.fetchData() }
        this.copying = false
      }).catch(() => { this.copying = false })
    },
    async exportData() {
      try {
        await exportSchedule({ weekStart: this.weekStart, weekEnd: this.weekEnd })
      } catch (e) { this.$message.error('导出失败') }
    }
  }
}
</script>

<style scoped>
.schedule-page { padding: 0 16px; height: calc(100vh - 56px); display: flex; flex-direction: column; overflow: hidden; }
.title-row { display: flex; justify-content: space-between; align-items: center; flex-shrink: 0; padding: 8px 0 4px; }
.title-left { display: flex; align-items: center; }
.page-title { font-size: 20px; font-weight: 700; color: #1E293B; margin-right: 10px; }
.page-date-tag { display: inline-flex; align-items: center; padding: 3px 10px; border-radius: 20px; background: #F1F5F9; color: #64748B; font-size: 12px; }
.title-actions { display: flex; align-items: center; }
.title-actions .el-button { margin-left: 8px; }
/* 统计卡片 */
.stats-row { display: grid; grid-template-columns: repeat(3, 1fr); grid-gap: 10px; flex-shrink: 0; margin-bottom: 8px; }
.stat-card { background: #fff; border-radius: 12px; border: 1px solid #E8EDF3; box-shadow: 0 1px 4px rgba(0,0,0,0.06); display: flex; align-items: center; overflow: hidden; position: relative; }
.sc-left { width: 72px; min-width: 72px; align-self: stretch; display: flex; align-items: center; justify-content: center; }
.sc-icon { font-size: 26px; color: #fff; }
.sc-green { background: linear-gradient(160deg, #34D399, #059669); }
.sc-orange { background: linear-gradient(160deg, #FBBF24, #D97706); }
.sc-blue { background: linear-gradient(160deg, #60A5FA, #2563EB); }
.sc-right { flex: 1; padding: 14px 12px 10px; }
.sc-num { font-size: 28px; font-weight: 800; color: #1E293B; line-height: 1; }
.sc-label { font-size: 12px; font-weight: 600; color: #475569; margin-top: 5px; }
.sc-sub { font-size: 11px; color: #94A3B8; margin-top: 2px; }
.sc-badge { position: absolute; top: 10px; right: 10px; font-size: 10px; font-weight: 600; padding: 2px 7px; border-radius: 8px; }
.sc-badge-green { background: #DCFCE7; color: #16A34A; }
.sc-badge-orange { background: #FEF3C7; color: #D97706; }
.sc-progress-wrap { position: absolute; bottom: 10px; left: 184px; right: 10px; display: flex; align-items: center; }
.sc-progress-bar { flex: 1; height: 4px; border-radius: 2px; background: #DBEAFE; overflow: hidden; margin-right: 6px; }
.sc-progress-fill { height: 100%; border-radius: 2px; background: #2563EB; }
.sc-progress-pct { font-size: 11px; font-weight: 700; color: #2563EB; white-space: nowrap; }
/* 主卡片 */
.main-card { flex: 1; min-height: 0; background: #fff; border-radius: 12px; border: 1px solid #E2E8F0; box-shadow: 0 2px 8px rgba(0,0,0,0.06); display: flex; flex-direction: column; overflow: hidden; }
/* 筛选栏 */
.filter-bar { display: flex; align-items: center; justify-content: space-between; padding: 8px 14px; border-bottom: 1px solid #F1F5F9; flex-shrink: 0; background: #FAFBFC; }
.filter-left { display: flex; align-items: center; flex-wrap: wrap; }
.filter-left > * { margin-right: 8px; }
.filter-right { display: flex; align-items: center; }
.filter-divider { width: 1px; height: 18px; background: #E2E8F0; flex-shrink: 0; margin-right: 8px; }
.date-nav-group { display: flex; align-items: center; border: 1px solid #E2E8F0; border-radius: 8px; overflow: hidden; background: #fff; }
.date-nav-group .el-button { border: none; border-radius: 0; background: transparent; padding: 6px 8px; }
.date-range-label { padding: 4px 12px; font-size: 12px; font-weight: 600; color: #1E293B; white-space: nowrap; border-left: 1px solid #E2E8F0; border-right: 1px solid #E2E8F0; }
.quick-jump-group { display: flex; align-items: center; border: 1px solid #E2E8F0; border-radius: 8px; overflow: hidden; background: #fff; }
.quick-jump-btn { padding: 4px 12px; font-size: 12px; font-weight: 500; color: #64748B; cursor: pointer; white-space: nowrap; }
.quick-jump-btn + .quick-jump-btn { border-left: 1px solid #E2E8F0; }
.quick-jump-btn:hover { background: #F1F5F9; color: #1E293B; }
.quick-jump-btn.active { background: #2563EB; color: #fff; }
.view-switch { display: flex; align-items: center; border: 1px solid #E2E8F0; border-radius: 8px; overflow: hidden; background: #fff; }
.view-btn { display: flex; align-items: center; padding: 5px 14px; font-size: 12px; font-weight: 500; color: #64748B; cursor: pointer; white-space: nowrap; }
.view-btn + .view-btn { border-left: 1px solid #E2E8F0; }
.view-btn:hover { background: #F1F5F9; color: #1E293B; }
.view-btn.active { background: #2563EB; color: #fff; }
/* 时间视图 */
.schedule-wrap { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.s-scroll-x { flex: 1; min-height: 0; overflow: auto; }
.s-table { border-collapse: collapse; width: 100%; min-width: max-content; }
.s-th-date { width: 130px; min-width: 130px; padding: 10px 12px; text-align: center; font-size: 13px; font-weight: 600; color: #64748B; background: #F8FAFC; border-bottom: 2px solid #E2E8F0; border-right: 1px solid #E2E8F0; position: sticky; left: 0; z-index: 3; }
.s-th-shift { min-width: 200px; max-width: 260px; padding: 10px 14px; background: #F8FAFC; border-bottom: 2px solid #E2E8F0; border-right: 1px solid #E2E8F0; }
.s-th-shift:last-child { border-right: none; }
.s-th-shift-inner { display: flex; align-items: center; }
.s-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-right: 8px; }
.s-shift-name { font-size: 12px; font-weight: 600; color: #1E293B; }
.s-shift-time { font-size: 11px; color: #94A3B8; margin-top: 1px; }
.s-td-date { width: 130px; min-width: 130px; padding: 10px 12px; text-align: center; border-right: 1px solid #E2E8F0; vertical-align: middle; background: #fff; position: sticky; left: 0; z-index: 1; }
.is-today .s-td-date { background: #EFF6FF; }
.s-week { font-size: 11px; color: #94A3B8; font-weight: 500; display: block; }
.s-day { font-size: 16px; font-weight: 700; color: #1E293B; margin-top: 2px; display: block; }
.today-circle { background: #2563EB; color: #fff; border-radius: 50%; width: 30px; height: 30px; display: inline-flex; align-items: center; justify-content: center; font-size: 13px; margin: 0 auto; }
.s-td-cell { min-width: 200px; max-width: 260px; padding: 6px 8px; vertical-align: top; border-right: 1px solid #F1F5F9; height: 1px; }
.s-td-cell:last-child { border-right: none; }
.cell-warn { background: #FFFBEB; }
.s-cell-inner { display: flex; flex-direction: column; min-height: 64px; height: 100%; }
.s-cell-inner > * { margin-bottom: 4px; }
.staff-chip { display: flex; align-items: center; padding: 6px 10px; border-radius: 6px; cursor: pointer; overflow: hidden; min-width: 0; }
.staff-chip:hover { opacity: 0.8; }
.chip-avatar { width: 24px; height: 24px; border-radius: 50%; flex-shrink: 0; color: #fff; font-size: 11px; font-weight: 700; display: flex; align-items: center; justify-content: center; margin-right: 7px; }
.chip-name { font-size: 12px; font-weight: 600; color: #1E293B; flex-shrink: 0; max-width: 60px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 4px; }
.chip-rooms { font-size: 11px; color: #64748B; flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: flex; align-items: center; }
.chip-rooms-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; }
.empty-warn { display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 10px 12px; text-align: center; border: 1.5px solid #FDE68A; border-radius: 6px; background: #FFFBEB; }
.warn-inner { display: flex; align-items: center; margin-bottom: 8px; }
.warn-inner > i { margin-right: 8px; }
.warn-content { display: flex; flex-direction: column; text-align: left; }
.warn-title { font-size: 12px; font-weight: 600; color: #92400E; line-height: 1.4; }
.warn-desc { font-size: 11px; color: #B45309; }
.warn-btn { display: inline-flex; align-items: center; font-size: 12px; font-weight: 600; color: #92400E; cursor: pointer; padding: 5px 14px; border-radius: 6px; background: #FCD34D; border: 1px solid #F59E0B; }
.warn-btn:hover { background: #FBBF24; }
.warn-btn > i { margin-right: 4px; }
.missing-rooms-warn { padding: 6px 8px; border-radius: 6px; background: #FFFBEB; border: 1px dashed #FCD34D; display: flex; flex-direction: column; }
.missing-rooms-header { display: flex; align-items: center; margin-bottom: 4px; }
.missing-rooms-header > i { margin-right: 5px; }
.missing-rooms-title { font-size: 11px; font-weight: 600; color: #D97706; flex: 1; }
.missing-rooms-btn { display: inline-flex; align-items: center; font-size: 11px; font-weight: 600; color: #92400E; cursor: pointer; padding: 2px 8px; border-radius: 4px; background: #FCD34D; border: 1px solid #F59E0B; flex-shrink: 0; }
.missing-rooms-btn:hover { background: #FBBF24; }
.missing-rooms-btn > i { margin-right: 3px; }
.missing-rooms-list { display: flex; align-items: center; flex-wrap: wrap; }
.missing-rooms-list > * { margin-right: 3px; margin-top: 2px; }
.missing-room-tag { padding: 1px 5px; border-radius: 3px; background: #FEF3C7; color: #92400E; font-size: 10px; font-weight: 500; }
.missing-room-more { font-size: 10px; color: #B45309; }
.s-legend { display: flex; align-items: center; flex-wrap: wrap; padding: 5px 14px; border-top: 1px solid #F1F5F9; flex-shrink: 0; font-size: 11px; color: #64748B; background: #FAFAFA; }
.s-legend > * { margin-right: 10px; }
.legend-item { display: flex; align-items: center; }
.legend-dot { width: 8px; height: 8px; border-radius: 50%; margin-right: 5px; }
.legend-sep { width: 1px; height: 14px; background: #E2E8F0; }
/* 新增弹窗 */
.add-modal { display: flex; flex-direction: column; max-height: 85vh; }
.add-modal-header { display: flex; justify-content: space-between; align-items: center; padding: 18px 22px 14px; border-bottom: 1px solid #E2E8F0; }
.add-modal-title { font-size: 17px; font-weight: 600; color: #1E293B; }
.add-modal-close { width: 30px; height: 30px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.add-modal-close:hover { background: #F1F5F9; }
.add-modal-body { flex: 1; overflow-y: auto; padding: 18px 22px; display: flex; flex-direction: column; }
.add-modal-body > * { margin-bottom: 16px; }
.add-modal-footer { display: flex; align-items: center; justify-content: flex-end; padding: 12px 22px; border-top: 1px solid #E2E8F0; }
.add-modal-footer .el-button { margin-left: 8px; }
.edit-info-bar { display: flex; align-items: flex-start; padding: 12px 14px; border-radius: 8px; background: #EFF6FF; border: 1px solid #BFDBFE; }
.edit-info-title { font-size: 13px; font-weight: 500; color: #1E293B; }
.edit-info-sub { font-size: 11px; color: #64748B; margin-top: 2px; }
.add-field { display: flex; flex-direction: column; }
.add-label { font-size: 14px; font-weight: 500; color: #374151; margin-bottom: 8px; }
.req { color: #EF4444; margin-left: 2px; }
.shift-btn-row { display: flex; flex-wrap: wrap; }
.shift-btn-row > * { margin-right: 10px; margin-bottom: 8px; }
.shift-btn { display: flex; align-items: center; padding: 10px 14px; border-radius: 8px; cursor: pointer; border: 1.5px solid #E2E8F0; background: #fff; min-width: 120px; }
.shift-btn:hover { border-color: #93C5FD; }
.shift-btn.active { border-color: #2563EB; }
.shift-btn-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; margin-right: 8px; }
.shift-btn-name { font-size: 13px; font-weight: 600; color: #1E293B; }
.shift-btn-time { font-size: 11px; color: #94A3B8; margin-top: 1px; }
.room-input-box { display: flex; align-items: center; flex-wrap: wrap; min-height: 40px; padding: 8px 12px; border-radius: 8px; background: #F9FAFB; border: 1.5px solid #E2E8F0; cursor: pointer; }
.room-input-box:hover { border-color: #93C5FD; }
.room-input-box > * { margin-right: 6px; margin-top: 2px; }
.room-placeholder { color: #94A3B8; font-size: 13px; }
.room-tag { display: inline-flex; align-items: center; padding: 2px 8px; border-radius: 4px; background: #EFF6FF; color: #2563EB; font-size: 12px; }
.room-tag > i { margin-left: 4px; }
.room-add-btn { display: inline-flex; align-items: center; color: #2563EB; font-size: 12px; cursor: pointer; }
.room-add-btn > i { margin-right: 3px; }
.room-hint { font-size: 12px; color: #94A3B8; margin-top: 4px; }
.quick-row { display: flex; align-items: center; flex-wrap: wrap; margin-top: 6px; }
.quick-row > * { margin-right: 6px; margin-top: 4px; }
.quick-label { font-size: 12px; color: #94A3B8; }
.quick-btn { padding: 3px 10px; border-radius: 4px; font-size: 12px; cursor: pointer; background: #F1F5F9; border: 1px solid #E2E8F0; color: #475569; }
.quick-btn:hover { background: #E2E8F0; }
.date-row { display: flex; align-items: center; }
/* 复制弹窗 */
.cp-modal { display: flex; flex-direction: column; max-height: 90vh; border-radius: 12px; overflow: hidden; }
.cp-modal-header { display: flex; align-items: center; justify-content: space-between; padding: 18px 22px; background: linear-gradient(135deg, #1E40AF 0%, #2563EB 100%); }
.cp-modal-header-left { display: flex; align-items: center; }
.cp-modal-icon { width: 40px; height: 40px; border-radius: 10px; background: rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-right: 14px; }
.cp-modal-title { font-size: 16px; font-weight: 700; color: #fff; }
.cp-modal-sub { font-size: 12px; color: rgba(255,255,255,0.7); margin-top: 2px; }
.cp-modal-close { width: 30px; height: 30px; border-radius: 8px; cursor: pointer; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.15); }
.cp-modal-close:hover { background: rgba(255,255,255,0.25); }
.cp-modal-body { flex: 1; overflow-y: auto; padding: 18px 22px; display: flex; flex-direction: column; background: #F8FAFC; }
.cp-modal-body > * { margin-bottom: 16px; }
.cp-modal-footer { display: flex; align-items: center; justify-content: flex-end; padding: 12px 22px; border-top: 1px solid #E2E8F0; background: #fff; }
.cp-modal-footer .el-button { margin-left: 8px; }
.cp-block { background: #fff; border-radius: 10px; padding: 14px; border: 1px solid #E8EDF3; box-shadow: 0 1px 3px rgba(0,0,0,0.04); }
.cp-block-title { display: flex; align-items: center; font-size: 13px; font-weight: 700; color: #1E293B; margin-bottom: 12px; }
.cp-block-dot { width: 4px; height: 14px; border-radius: 2px; flex-shrink: 0; margin-right: 7px; }
.cp-dot-blue { background: #2563EB; }
.cp-dot-orange { background: #D97706; }
.cp-required { color: #EF4444; margin-left: 2px; }
.cp-source-box { display: flex; align-items: center; padding: 12px 14px; border-radius: 8px; background: #EFF6FF; border: 1px solid #BFDBFE; }
.cp-source-icon { width: 34px; height: 34px; border-radius: 8px; background: #DBEAFE; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-right: 12px; }
.cp-source-info { flex: 1; }
.cp-source-week { font-size: 13px; font-weight: 600; color: #1E293B; }
.cp-source-range { font-size: 12px; color: #64748B; margin-top: 1px; }
.cp-current-tag { padding: 3px 10px; border-radius: 10px; background: #2563EB; color: #fff; font-size: 11px; font-weight: 600; }
.cp-target-grid { display: grid; grid-template-columns: repeat(4, 1fr); grid-gap: 8px; }
.cp-target-card { display: flex; flex-direction: column; align-items: center; padding: 12px 8px; border-radius: 10px; cursor: pointer; text-align: center; border: 2px solid #E2E8F0; background: #F8FAFC; }
.cp-target-card:hover { border-color: #93C5FD; background: #F0F7FF; }
.cp-target-card.active { border-color: #2563EB; background: #EFF6FF; }
.cp-card-check { width: 18px; height: 18px; border-radius: 50%; border: 2px solid #CBD5E1; display: flex; align-items: center; justify-content: center; background: #fff; flex-shrink: 0; margin-bottom: 6px; }
.cp-card-check.active { background: #2563EB; border-color: #2563EB; }
.cp-card-label { font-size: 13px; font-weight: 700; color: #1E293B; }
.cp-card-range { font-size: 11px; color: #94A3B8; margin-top: 2px; }
.cp-conflict-row { display: flex; }
.cp-conflict-row > * { margin-right: 10px; }
.cp-conflict-card { display: flex; align-items: center; flex: 1; padding: 12px 14px; border-radius: 8px; cursor: pointer; border: 1.5px solid #E2E8F0; background: #F8FAFC; }
.cp-conflict-card:hover { border-color: #93C5FD; }
.cp-conflict-card.active { border-color: #2563EB; background: #EFF6FF; }
.cp-conflict-radio { width: 16px; height: 16px; border-radius: 50%; border: 2px solid #CBD5E1; flex-shrink: 0; margin-right: 10px; }
.cp-conflict-radio.active { border-color: #2563EB; background: #2563EB; }
.cp-conflict-name { font-size: 13px; font-weight: 600; color: #1E293B; }
.cp-conflict-desc { font-size: 11px; color: #94A3B8; margin-top: 2px; }
</style>

<style>
.add-schedule-dialog .el-dialog__header { display: none; }
.add-schedule-dialog .el-dialog__body { padding: 0; }
.copy-schedule-dialog .el-dialog__header { display: none; }
.copy-schedule-dialog .el-dialog__body { padding: 0; }
</style>
